var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 26h14V16h-6.5c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0118 14.5V8h-6v18zm4-22.5v-1a.48.48 0 00-.148-.352A.48.48 0 0015.5 2h-11a.48.48 0 00-.352.148A.48.48 0 004 2.5v1c0 .135.05.253.148.352A.48.48 0 004.5 4h11a.48.48 0 00.352-.148A.48.48 0 0016 3.5zM20 14h4.672L20 9.328V14zm8 2v10.5c0 .417-.146.77-.438 1.063A1.446 1.446 0 0126.5 28h-15c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0110 26.5V24H1.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 010 22.5v-21C0 1.083.146.73.438.437A1.447 1.447 0 011.5 0h17c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v5.125c.219.135.406.281.563.438l6.375 6.375c.291.291.541.687.75 1.187.208.5.312.958.312 1.375z"
  })));
}

export default SvgClipboard;